import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ContentSkeleton = () => (
  <div className="content-skeleton">
    <div style={{ display: 'flex', gap: '10px' }}>
      <div style={{ width: '70px', height: '80px' }}>
        <Skeleton height="100%" borderRadius={5} />
      </div>
      <div style={{ flex: 1 }}>
        <Skeleton height={13} width="300px" style={{ marginBottom: '10px' }} />
        <Skeleton height={10} width="250px" />
      </div>
    </div>
  </div>
);

export const PageSkeleton = () => (
  <div className="page-skeleton" style={{ padding: '20px' }}>
    <Skeleton height={20} width="250px" style={{ marginBottom: '10px' }} />
    <Skeleton height={10} width="250px" style={{ marginBottom: '10px' }} />
    <Skeleton height={10} width="250px" style={{ marginBottom: '10px' }} />
    <Skeleton height={10} width="250px" style={{ marginBottom: '10px' }} />
    <Skeleton height={10} width="250px" />
  </div>
);

export default ContentSkeleton;
